import { useEffect } from 'react';

import get from 'lodash/get';
import { customerAssist } from '@virginmoney/api-connector-lib';

export const useConfirmationApi = (form) => {
  const handleSubmit = async (form = {}) => {
    const body = {
      sort_code: get(form, 'state.sortCode.value', '').split('-').join(''),
      account_number: get(form, 'state.accountNumber.value'),
      mobile_number: get(form, 'state.mobileNumber.value')
    };

    const baseUrl = `${window.__config.apiBaseUrlPaas}/ibapi/v2/`;
    await customerAssist.requestCustomerNumberBySCAN(baseUrl, body, 'CustomerNumberAssist');
  };

  useEffect(() => {
    handleSubmit(form);
  }, [form]);
};
